// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"search-field_searchIcon__23MLy","clearIcon":"search-field_clearIcon__3Yvmr"};